// extracted by mini-css-extract-plugin
export default {"bottomSlideUpSpinner":"editFilingDecisions_bottomSlideUpSpinner__QlWCI"};